import React from "react";
import { Translate } from "react-localize-redux";
import { auth } from "../../../App/routes";
import DataTable from "../../../utils/components/DataTable";
import Loading from "../../../utils/components/Loading";
import timeStampToDateFormat from "../../../utils/helpers/timestampToDateFormat";

const columns = [
  {
    name: <Translate id="dashboard.uppercase_translates.task_id" />,
    selector: (row) => row.task_id,
    sortable: true,
    cell: (row) => (
      <div className="row-status" data-status={row.status}>
        {row.task_id}
      </div>
    ),
  },
  {
    name: <Translate id="dashboard.uppercase_translates.form_name" />,
    selector: (row) => row.form.name,
    sortable: true,
  },
  {
    name: <Translate id="dashboard.uppercase_translates.form_no" />,
    selector: (row) => row.form.no,
    sortable: true,
  },
  {
    name: <Translate id="dashboard.uppercase_translates.status" />,
    selector: (row) => row.status,
    sortable: true,
    cell: (row) => <Translate id={`dashboard.${row.status}`} />,
  },
  {
    name: <Translate id="dashboard.uppercase_translates.assigned_to" />,
    selector: (row) => row.worker.name,
    sortable: true,
  },
  {
    name: <Translate id="dashboard.uppercase_translates.due_date" />,
    selector: (row) => row.due_date,
    sortable: true,
    cell: (row) => (
      <div>
        {row.due_date ? timeStampToDateFormat(row.due_date, "dd/MM/yyyy") : "-"}
      </div>
    ),
  },
];

const TasksList = ({
  tasks,
  project,
  activeTab,
  totalRows,
  handlePerRowsChange,
  handlePageChange,
  translate,
  isTasksLoading,
  perPage,
}) => {
  const handleNavigateToDetail = (row) => {
    if (row.statusNo === 2) return;

    window.open(
      auth.taskDetails.link.replace(":id", row.task_id) +
        `?locked=${row.locked}`
    );
  };

  return (
    <div className="my-tasks page page-shadow">
      <div className="row">
        <div className="col-12">
          {project ? (
            <DataTable
              columns={columns}
              data={tasks}
              highlightOnHover
              onRowClicked={(row) => handleNavigateToDetail(row)}
              conditionalRowStyles={[
                {
                  when: (row) => row.statusNo === 1,
                  classNames: [
                    "row-status",
                    "row-status--incompleted",
                    "cursor--pointer",
                  ],
                },
                {
                  when: (row) => row.statusNo === 2,
                  classNames: [
                    "row-status",
                    "row-status--completed",
                    "cursor--default",
                  ],
                },
                {
                  when: (row) => row.statusNo === 3,
                  classNames: [
                    "row-status",
                    "row-status--pending",
                    "cursor--pointer",
                  ],
                },
                {
                  when: (row) => row.statusNo === 0,
                  classNames: ["cursor--pointer"],
                },
              ]}
              noDataComponent={
                <p className="fw-bold text-center mt-3">
                  {translate("dashboard.no_task_related_to_project", {
                    project: project.name,
                  })}
                </p>
              }
              pagination
              paginationServer
              paginationTotalRows={totalRows}
              onChangeRowsPerPage={handlePerRowsChange}
              onChangePage={handlePageChange}
              progressPending={isTasksLoading}
              progressComponent={<Loading />}
              paginationPerPage={perPage}
            />
          ) : (
            <p className="fw-bold text-center">
              {translate("dashboard.please_select_a_project")}
            </p>
          )}
        </div>
      </div>
    </div>
  );
};
export default TasksList;
